module.exports = __webpack_public_path__ + "img/verdi_loader.086880e2.svg";